import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'InsightsItem' })({
    root: {
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        textDecoration: 'none'
    },
    primary: {
        color: '#232323',
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '20px'
    },
    secondary: {
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px'
    }
});
